import * as yup from 'yup';
import { apiRequest } from 'src/components/star-grid/services/starGridHttp';
import { ReportDefinitionApiError } from 'src/components/star-grid/utils/reportDefinitionError';
import { STUDIO_DECK_TYPES_PATH, STUDIO_SCENARIOS_PATH } from 'src/components/star-grid/reportStudioConstants';
const deckTypes = yup.array().of(yup.string().required()).required();
const scenarios = yup
  .array()
  .of(yup.object({ id: yup.string().required(), label: yup.string().required() }))
  .required();
const readOptions = async (path: string, signal?: AbortSignal): Promise<unknown> => {
  try {
    return await apiRequest(path, undefined, signal);
  } catch (error) {
    if (error instanceof ReportDefinitionApiError && [404, 405].includes(error.status)) return undefined;
    throw error;
  }
};
export const loadStudioDeckTypes = async (signal?: AbortSignal): Promise<string[] | undefined> => {
  const value = await readOptions(STUDIO_DECK_TYPES_PATH, signal);
  if (value === undefined) return undefined;
  const result = await deckTypes.validate(value, { strict: true });
  if (new Set(result.map((id) => id.toLowerCase())).size !== result.length) throw new Error('Duplicate Studio deck types');
  return result;
};
export const loadStudioScenarios = async (signal?: AbortSignal) => {
  const value = await readOptions(STUDIO_SCENARIOS_PATH, signal);
  if (value === undefined) return undefined;
  const result = await scenarios.validate(value, { strict: true });
  if (new Set(result.map((item) => item.id)).size !== result.length) throw new Error('Duplicate Studio scenarios');
  return result;
};
